import React, { useCallback } from 'react';
import CustomBadge from 'components/ui/custom-badge';
import { useTranslation } from 'react-i18next';
import { PremiumDueResponseDtoPremiumStatusEnum } from 'libs/pinnacle-sdk';

interface PremiumStatusIndicatorProps {
  status: PremiumDueResponseDtoPremiumStatusEnum;
}
const PremiumStatusIndicator: React.FC<PremiumStatusIndicatorProps> = ({
  status,
}) => {
  const { t } = useTranslation();
  const getPremiumStatusConfig = useCallback(
    (status: PremiumDueResponseDtoPremiumStatusEnum) => {
      switch (status) {
        case PremiumDueResponseDtoPremiumStatusEnum.Current:
          return {
            bg: 'bg-blue-100',
            text: 'text-blue-600',
            label: t('premiumDue.current'),
          };
        case PremiumDueResponseDtoPremiumStatusEnum.Overdue30Days:
          return {
            bg: 'bg-yellow-100',
            text: 'text-yellow-600',
            label: t('premiumDue.overdue30Days'),
          };
        case PremiumDueResponseDtoPremiumStatusEnum.Overdue60Days:
          return {
            bg: 'bg-orange-100',
            text: 'text-orange-600',
            label: t('premiumDue.overdue60Days'),
          };

        case PremiumDueResponseDtoPremiumStatusEnum.Overdue90Days:
          return {
            bg: 'bg-red-100',
            text: 'text-red-600',
            label: t('premiumDue.overdue90Days'),
          };
        case PremiumDueResponseDtoPremiumStatusEnum.OverdueMoreThan90Days:
          return {
            bg: 'bg-red-400',
            text: 'text-red-900',
            label: t('premiumDue.overdueMoreThan90Days'),
          };

        case PremiumDueResponseDtoPremiumStatusEnum.Paid:
          return {
            bg: 'bg-green-100',
            text: 'text-green-600',
            label: t('premiumDue.paid'),
          };
        default:
          return {
            bg: 'bg-gray-100',
            text: 'text-gray-600',
            label: status,
          };
      }
    },
    [t]
  );

  const config = getPremiumStatusConfig(status);

  return (
    <CustomBadge
      label={config.label}
      backgroundColor={config.bg}
      textColor={config.text}
    />
  );
};

export default PremiumStatusIndicator;
